module.exports = __webpack_public_path__ + "static/media/feat_chapterCoffee.16935504.png";